import type { Distance, SpatialRectangle } from "@pdfking/math"
import { AddMargins, Max } from "@pdfking/math"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import type { PlotMedia as PlotMediaAction } from "@pdfking/renderer-api"

import { PlotMixin as mixin } from "../mixins/PlotMixin"
import { PlotImage } from "./PlotImage"

export const PlotMedia = CreateRenderFunction({
  computed: {
    // `position` grown by the signed mask: what stays visible. It stays where
    // it is, whatever the media's own transform does to the page under it.
    mask_box(): SpatialRectangle<Distance> {
      const { position, mask } = this.action
      return AddMargins(position, mask)
    },
    page_color(): string {
      if (this.page_number) {
        const tot = Max(this.media_count, 4)
        const hue = ((this.page_number - 1) / tot + 0.5) % 1
        return `hsla(${hue * 360}, 100%, 95%, 0.25)`
      }
      return "transparent"
    },
    page_number(): number | undefined {
      return this.page_pages[this.action.filename]
    },
  },
  mixins: [mixin] as const,
  props: {
    action: {} as PlotMediaAction,
    media_count: 0,
    page_pages: {} as Record<string, number>,
  },
  render() {
    const mask_box = this.mask_box
    return (
      <>
        {!this.printable && (
          <rect
            fill={this.page_color}
            height={this.get_h(mask_box)}
            transform={this.transform_coords(mask_box)}
            width={this.get_w(mask_box)}
          />
        )}
        <mask id={this.uuid}>
          <rect
            className="pointer-events-none"
            fill="white"
            height={this.get_h(mask_box)}
            transform={this.transform_coords(mask_box)}
            width={this.get_w(mask_box)}
          />
        </mask>
        <g className="pointer-events-none" mask={`url(#${this.uuid})`}>
          <PlotImage
            action={this.action}
            context={this.context}
            printable={this.printable}
            request_media={this.request_media}
          />
        </g>
        {this.media_click && (
          <rect
            className="cursor-pointer"
            fill="transparent"
            height={this.get_h(this.action.position)}
            onClick={(e: MouseEvent) => {
              e.stopPropagation()
              e.preventDefault()
              this.media_click!(this.uuid, this.action, e.currentTarget as SVGGraphicsElement)
            }}
            transform={this.transform_coords(this.action.position)}
            width={this.get_w(this.action.position)}
          />
        )}
      </>
    )
  },
})
